// extracted by mini-css-extract-plugin
export default {"grid":"FinanceCostList_grid__LoPKu"};